import { render } from "./FoydaliHavolalar.vue?vue&type=template&id=60ec59cc"
import script from "./FoydaliHavolalar.vue?vue&type=script&lang=js"
export * from "./FoydaliHavolalar.vue?vue&type=script&lang=js"

import "./FoydaliHavolalar.vue?vue&type=style&index=0&id=60ec59cc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__